import { createAction } from '@'
import FetchMappingCoverage from './FetchMappingCoverage'
import { $hotelCoverage, $hotelCoverageLoading, $hotelCoverageQuery } from '../stores'

export default createAction('GetHotelCoverage', async params => {
    const last = $hotelCoverageQuery.getState()
    const query = { hotel_id: `${params.hotel_id}`.trim() }
    const isLatest = () => $hotelCoverageQuery.getState() === query

    $hotelCoverageQuery.setState(() => query)
    if (!last || last.hotel_id !== query.hotel_id) {
        $hotelCoverage.setState(() => null)
    }
    $hotelCoverageLoading.setState(() => true)
    try {
        const data = await FetchMappingCoverage({ method: 'GET', path: '/hotel', params: query }, { silent: true })
        if (isLatest()) {
            $hotelCoverage.setState(() => data)
        }
    } catch (e) {
        // 404 / 400 bodies carry a readable message — show it instead of an empty page.
        if (isLatest()) {
            $hotelCoverage.setState(() => e.data || { success: false, message: e.message })
        }
    } finally {
        if (isLatest()) {
            $hotelCoverageLoading.setState(() => false)
        }
    }
})
